import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { DTOSearchSettings } from '@shared/dto/search/dto_search_settings';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { createAsyncThunkSafe } from '../_base/createAsyncThunkSafe';
import { StateSearch } from './state_search';

export const remote_search_update = createAsyncThunkSafe<void, DTOSearchSettings>(
  ENUM__network_event_client_to_server.SEARCH_UPDATE,
  async (search_settings): Promise<void> => {
    await send_to_server(ENUM__network_event_client_to_server.SEARCH_UPDATE, search_settings);
  },
);

export function init_remote_search_update(builder: ActionReducerMapBuilder<StateSearch>) {
  builder
    .addCase(remote_search_update.pending, (state, action) => {
      if (action.meta.arg._id == state.search_current._id) {
        state.search_current = action.meta.arg;
      }
    })
    .addCase(remote_search_update.rejected, (state, action) => {})
    .addCase(remote_search_update.fulfilled, (state, action: PayloadAction) => {});
}
